<div class="tag-input" [class.tag-input--disabled]="isDisabled">
  <span class="tag-input__tag" *ngFor="let value of values; let i = index">
    {{ value }}
    <button
      type="button"
      class="tag-input__remove"
      [disabled]="isDisabled"
      [attr.aria-label]="('SB_Remove' | translate) + ' ' + value"
      (click)="remove(i)"
    >
      &times;
    </button>
  </span>
  <input
    type="text"
    class="tag-input__input"
    [id]="inputId"
    [attr.aria-label]="ariaLabel"
    [disabled]="isDisabled"
    [placeholder]="values.length ? '' : (placeholder | translate)"
    [(ngModel)]="pending"
    (keydown)="onKeyDown($event)"
    (blur)="onBlur()"
  />
</div>
